import { computed, type ComputedRef } from 'vue';
import type { SuiDataTableColumnType } from '@developers/scoro-ui';
import { TABLE_COLUMN } from '../../constants';
import { type CellDefinition } from '../../types';

export const useTaskListRowCells = ({
	colDefinition,
}: {
	colDefinition: ComputedRef<SuiDataTableColumnType[]>;
}): {
	orderedCells: ComputedRef<CellDefinition[]>;
} => {
	const orderedCells = computed<CellDefinition[]>(() => {
		return colDefinition.value.map((col) => {
			const cell: CellDefinition = {
				columnId: col.id,
				align: col.align,
			};

			if (
				[
					TABLE_COLUMN.DueDate,
					TABLE_COLUMN.Budget,
					TABLE_COLUMN.RemainingBudget,
					TABLE_COLUMN.Planned,
					TABLE_COLUMN.Done,
					TABLE_COLUMN.Remaining,
				].includes(col.id)
			) {
				cell.isNumber = true;
			}

			return cell;
		});
	});

	return {
		orderedCells,
	};
};
